import clsx from 'clsx';
import React from 'react';

const InputLabel = (props: React.ComponentProps<'label'>) => (
  <label {...props} className={clsx('tw-font-bold', props.className)}>
    {props.children}
  </label>
);
export default InputLabel;
